var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 875,
    height: 284,
    viewBox: "0 0 875 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 530.694,
    cy: 107.665,
    r: 46.6861,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.968,
    cy: 201.036,
    r: 82.8916,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.056,
    cy: 69.5526,
    r: 48.5916,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.766,
    cy: 117.192,
    r: 37.1583,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.967,
    cy: 42.8751,
    r: 37.1583,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9885,
    cy: 132.607,
    r: 17.0657,
    transform: "rotate(38.7132 23.9885 132.607)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.199,
    cy: 94.4953,
    r: 17.0657,
    transform: "rotate(38.7132 645.199 94.4953)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.887,
    cy: 23.9894,
    r: 17.0657,
    transform: "rotate(38.7132 812.887 23.9894)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.2932,
    cy: 107.841,
    r: 7.58126,
    transform: "rotate(38.7132 58.2932 107.841)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.553,
    cy: 109.745,
    r: 7.58126,
    transform: "rotate(38.7132 456.553 109.745)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 605.186,
    cy: 145.952,
    r: 7.58126,
    transform: "rotate(38.7132 605.186 145.952)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.344,
    cy: 62.1063,
    r: 7.58126,
    transform: "rotate(38.7132 864.344 62.1063)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobGroup);
export default __webpack_public_path__ + "static/media/blob-group.419d382ce12afc5755a7004478318b7b.svg";
export { ForwardRef as ReactComponent };